import React from 'react'
import HttpServices from '../../utils/Http.services'
import { checkTextTranslation, checkTranslation, imageAddress, pathMaker, translate } from '../../utils/useful'
import TLink from '../TLink'

class UserIndicator extends React.Component {
    state = {
        data: {}
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data != this.props.data) {
            this.init()
        }
    }

    // changeInputValue(target) {
    //     let value = (target.validity.valid) ? target.value : null
    //     if (value !== null) {
    //         this.props.changeValue(this.props.header.key, value, this.props.extra)
    //     }
    // }

    init = () => {
        if (this.props.data) {
            if (typeof this.props.data != 'object') {
                this.fetchUser()
            }
        } else {
            this.setState({ data: {} })
        }
    }

    fetchUser = () => {
        let address = "getOneUserLimitedInfo"
        HttpServices.request(address, { id: this.props.data }, (fetchResult, fetchError) => {
            // console.log(fetchResult)
            // console.log(fetchError)

            if (fetchResult?.info) {
                this.setState({ data: fetchResult.info })
            }
        })
    }


    render() {
        if ((this.props.data && this.props.data.username) || (this.state.data && this.state.data.username)) {
            if (typeof this.props.data == 'object') {
                return (

                    <div target="_blank" className="w-100 h-100 flexc py-1" style={{ overflow: 'hidden' }}>
                        <div className="flexcc">
                            <img src={imageAddress(this.props.data?.image, 'profile', 'small')} width="40px" style={{ border: '1px solid #eee', borderRadius: 50, height: 40, objectFit: 'cover' }} />
                        </div>
                        <div className="mld-2 w-100 " style={{ display: 'inline-block' }}>
                            <p className="text-normal text-bold" style={{ width: '80%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(this.props.data?.fullname)}</p>
                            <div>
                                <a href={pathMaker('/' + this.state.data.username)} target="_blank" > <p className="text-smaller " style={{ width: '80%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', color: '#789' }}>@{this.props.data?.username}</p></a>
                            </div>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div className="w-100 h-100 flexc py-1" style={{ overflow: 'hidden' }}>
                        <div className="flexcc">
                            <img src={imageAddress(this.state.data?.image, 'profile', 'small')} width="40px" style={{ border: '1px solid #eee', borderRadius: 50, height: 40, objectFit: 'cover' }} />
                        </div>
                        <div className="mld-2 w-100 " style={{ display: 'inline-block' }}>
                            <p className="text-normal text-bold" style={{ width: '80%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTextTranslation(this.state.data?.fullname)}</p>
                            <div>
                                <a href={pathMaker('/' + this.state.data.username)} target="_blank" ><p className="text-smaller " style={{ width: '80%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', color: '#789' }}>@{this.state.data?.username}</p></a>
                            </div>
                        </div>
                    </div>
                )
            }
        } else {
            return (
                <div className="px-1 w-100">
                    <p className="text-normal text-bold main-x5" style={{}}>{translate('Virtual User')}</p>
                    <p className="text-smaller mt-1" style={{ color: '#789', }}>{translate('This user is not in the platform but can be accessed in account')}</p>
                    <p className="text-smaller " style={{ color: '#789', }}>{translate('Virtual users can later be assigned to real users')}</p>
                </div>
            )
        }
    }
}

export default (UserIndicator);